import { useState } from 'react';
import { lumi } from '../lib/lumi';
import toast from 'react-hot-toast';

const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim();

    if (!isValidEmail(trimmed)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);
    try {
      const result: any = await lumi.functions.invoke('subscribeNewsletter', {
        method: 'POST',
        body: {
          email: trimmed,
          source: 'home_newsletter'
        }
      });

      if (result?.error) {
        throw new Error(result.error);
      }

      setIsSuccess(true);
      setEmail('');
      toast.success('Thank you for joining!');
    } catch (error: any) {
      console.error('Newsletter subscription failed:', error);
      toast.error(error?.message || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return;






































};

export default NewsletterSection;